import React, { Fragment, Dispatch, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import { Dialog } from '@material-ui/core';
import TextField from "@material-ui/core/TextField";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import WarningIcon from "@material-ui/icons/Warning";
import { saveReturnRequestAPI, getReturnSalesReasonAPI } from "../../store/actions/delivery.actions";
import FullscreenLoader from './../../common/components/FullscreenLoader';
import _, { get } from "lodash";
import { deletePartnerDocument, resetValues, updateDocument, getNationality } from '../../store/actions/editDealer.actions';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
        margin: "0 20px 35px 0",
        height: "100%",
        fill: "white",
    },
    yes: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1A9FE0',
        textTransform: 'capitalize'
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    cancelText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit',
    },
    dialogPaper: {
        borderRadius: 12,
        padding: 0,
    },
    root: {
        width: '100%',
    },
    addUpdateDailogTitle: {
        position: "absolute",
        top: 25,
        left: 5
    },
    addUpdateDailog: {
        top: 10,
        left: 4,
    },
    invoiceNumber: {
        fontSize: '0.913rem',
        fontFamily: 'Nunito',
        fontWeight: 800,
        color: '#2c2b2bff',
        marginLeft: 8,
    },
    dialogContent: {
        padding: '24px 0px 36px 0px',
    },
    tableHeader: {
        display: 'grid',
        gridTemplateColumns: '300px 200px',
        gap: '20px',
        padding: '12px 0 12px 22px',
        borderBottom: '1px solid #d4e8f8ff',
        marginBottom: 6,
    },
    headerCell: {
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#2196F3',
        lineHeight: 1.3,
    },
    tableRow: {
        display: 'grid',
        gridTemplateColumns: '280px 180px',
        gap: '40px',
        padding: '10px 0 10px 22px',
        alignItems: 'start',
        justifyContent: 'start'
    },
    cellText: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#333333',
    },
    inputField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 20,
            fontSize: '0.813rem',
            fontFamily: 'Nunito',
            backgroundColor: '#ffffff',
        },
        '& .MuiOutlinedInput-input': {
            padding: '8px 14px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#CCCCCC',
        },
    },
    selectField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 20,
            fontSize: '0.813rem',
            fontFamily: 'Nunito',
            backgroundColor: '#ffffff',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#CCCCCC',
        },
    },
    browseButton: {
        backgroundColor: '#1DA1F2',
        color: '#ffffff',
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 600,
        textTransform: 'none',
        padding: '8px 20px',
        borderRadius: 20,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#1a8cd8',
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: '#CCCCCC',
            color: '#666666',
        },
    },
    fileInfo: {
        fontSize: '0.688rem',
        fontFamily: 'Nunito',
        color: '#999999',
        marginTop: 4,
        lineHeight: 1.4,
    },
    warningText: {
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        color: '#FF9800',
        fontWeight: 500,
        marginTop: 6,
    },
    mandatoryText: {
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        color: '#FF9800',
        fontWeight: 500,
        marginTop: 6,
    },
    dialogActions: {
        padding: '25px 36px 24px',
        justifyContent: 'flex-end',
        gap: 12,
        borderTop: '1px solid #e0e0e0',
    },
    proceedButton: {
        backgroundColor: '#1DA1F2',
        color: '#ffffff',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 40px',
        borderRadius: 24,
        minWidth: 140,
        '&:hover': {
            backgroundColor: '#1a8cd8',
        },
    },
    closeButton: {
        backgroundColor: '#E0E0E0',
        color: '#666666',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 40px',
        borderRadius: 24,
        minWidth: 140,
        '&:hover': {
            backgroundColor: '#D0D0D0',
        },
    },
    uploadDialog: {
        '& .MuiDialog-paper': {
            borderRadius: 12,
            maxWidth: 650,
            width: '100%',
        }
    },
    uploadTableHeader: {
        display: 'grid',
        gridTemplateColumns: '200px 200px 150px',
        gap: '16px',
        padding: '8px 0',
        borderBottom: '2px solid #d5dfe7ff',
        marginBottom: 12,
    },
    uploadTableRow: {
        display: 'grid',
        gridTemplateColumns: '200px 200px 150px',
        gap: '16px',
        padding: '8px 0',
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
    },
    uploadCellTitle: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 400,
        color: '#333333',
    },
    uploadNote: {
        fontSize: '0.688rem',
        fontFamily: 'Nunito',
        color: '#999999',
        marginTop: 20,
        lineHeight: 1.4,
    },
    uploadActions: {
        padding: '12px 24px 16px',
        justifyContent: 'right',
        gap: 20,
        marginTop: "16px",
        marginBottom: "16px",
    },
    uploadButton: {
        backgroundColor: '#1DA1F2',
        color: '#ffffff',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 40px',
        borderRadius: 24,
        minWidth: 140,
        '&:hover': {
            backgroundColor: '#1a8cd8',
        },
    },
    cancelButton: {
        backgroundColor: '#E0E0E0',
        color: '#666666',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'none',
        padding: '10px 40px',
        borderRadius: 24,
        minWidth: 140,
        '&:hover': {
            backgroundColor: '#D0D0D0',
        },
    },
    progressContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
    },
    progressBar: {
        flex: 1,
        height: 4,
        backgroundColor: '#E0E0E0',
        borderRadius: 2,
        overflow: 'hidden',
        position: 'relative',
    },
    progressFill: {
        height: '100%',
        backgroundColor: '#1DA1F2',
        transition: 'width 0.3s ease',
    },
    fileInfoText: {
        fontSize: '0.688rem',
        fontFamily: 'Nunito',
        color: '#666666',
        marginLeft: 4,
    },
    title: {
        flex: '1 1 100%',
    },
}));

// Change the UploadedFile interface to not extend File
interface UploadedFile {
    id?: string;
    url?: string;
    documentStatus?: string;
    selectedFileName?: string;
    name?: string;
    size?: number;
    type?: string;
    lastModified?: number;
}

interface ReturnReason {
    code: string;
    message: string;
    sapMessage?: string;
    sapCode?: string;
    mandatory?: boolean;
}

export default function ReturnAllRequestPopup(props: any) {
    const classes = useStyles();
    const { handleopenClose, onReturnSuccess, existingReturnData, isUpdateMode, currentEtag } = props;
    const [fileIndexToDelete, setFileIndexToDelete] = React.useState<number | undefined>();
    const [returnQty, setReturnQty] = React.useState<any>('');
    const [selectedReason, setSelectedReason] = React.useState<string>('');
    const [showReasonWarning, setShowReasonWarning] = React.useState<boolean>(false);
    const [showReasonWarningIncase, setShowReasonWarningIncase] = React.useState<boolean>(false);
    const [showUploadDialog, setShowUploadDialog] = React.useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = React.useState<boolean>(false);
    const [uploadedFiles, setUploadedFiles] = React.useState<{ [key: string]: UploadedFile[] }>({});
    const [reasonError, setReasonError] = React.useState<boolean>(false);
    const [uploadError, setUploadError] = React.useState<boolean>(false);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [uploadProgress, setUploadProgress] = React.useState<{ [key: string]: number }>({});
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [loading, setLoading] = React.useState<any>(false);
    const [message, setMessage] = React.useState('');
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const [returnQtyError, setReturnQtyError] = React.useState<string>('');
    const [selectedReturnItem, setSelectedReturnItem] = React.useState<any>(null);
    const { billingDetails }: any = useSelector((state: any) => state.delivery);
    const [CloseButton, setCloseButton] = React.useState<boolean>(false);
    const [newlyUploadedFiles, setNewlyUploadedFiles] = React.useState<{ [key: string]: UploadedFile[] }>({});
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const customerName: any = sessionStorage.getItem("customerName");
    const dispatch: Dispatch<any> = useDispatch();
    // let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
    const billingData = billingDetails?.data?.data?.data;
    let sapCustomerId: any = billingData?.sapCustomerId || "";
    let etag: any = billingDetails?.data?.data?.data?._etag
    const [filesToDelete, setFilesToDelete] = React.useState<{ [key: string]: any }>({});
    const [documentIds, setDocumentIds] = React.useState<{ [key: string]: string }>({});
    const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = React.useState(false);
    const [fieldToDelete, setFieldToDelete] = React.useState<string>('');
    const [isBulkDelete, setIsBulkDelete] = React.useState<boolean>(false);
    const isFSE = sessionStorage.getItem('userType') === 'FSE' || sessionStorage.getItem('userType') === 'sre';
    const [mandatoryUploadsComplete, setMandatoryUploadsComplete] = React.useState<boolean>(false);

    useEffect(() => {
        dispatch(getReturnSalesReasonAPI());
    }, [dispatch]);

    // Formatted the customerTierType values
    const formatCustomerTier = (value: string | null) => {
        if (!value) return "";
        const trimmed = value.trim();
        const exactValues: Record<string, string> = {
            "tpc dealer": "tpcdealer",
            "tpcdealer": "tpcdealer",
            "int. business": "Int. Business",
            "int.business": "Int. Business",
            "tbl dealer": "TBL Dealer",
            "tbldealer": "TBL Dealer",
            "TBL Dealer": "TBL Dealer",
        };

        if (exactValues[value]) {
            return exactValues[value];
        }
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    };
    const unformatCustomerTier =
        (sessionStorage.getItem('userType') === 'FSE' ||
            sessionStorage.getItem('userType') === 'sre')
            ? sessionStorage.getItem('customerTierType') ||
            get(profileDetails, 'data.data.customerInfo.customerTierType', '')
            : get(profileDetails, 'data.data.customerInfo.customerTierType', '');

    const updatedCustomerTierType = formatCustomerTier(unformatCustomerTier?.toLowerCase() || "");

    const { getReturnSalesReason }: any = useSelector((state: any) => state.delivery);
    const returnReasons = Array.isArray(getReturnSalesReason?.data?.data)
        ? getReturnSalesReason.data.data
        : [];
    const reasonOptions: string[] = useMemo(() => {
        return (returnReasons as any[])
            .filter((r) => !r.mandatory)
            .map((r) => `${r.sapCode} - ${r.sapMessage}`);
    }, [returnReasons]);

    const warningReasons = useMemo(() => {
        return (returnReasons as any[])
            .filter((r) => !r.mandatory)
            .map((r) => `${r.sapCode} - ${r.sapMessage}`);
    }, [returnReasons]);

    const warningReasonsIncase = useMemo(() => {
        return (returnReasons as any[])
            .filter((r) => r.mandatory)
            .map((r) => `${r.sapCode} - ${r.sapMessage}`);
    }, [returnReasons]);

    // Get dynamic upload fields based on selected reason
    const getUploadFields = () => {
        return [
            { title: 'Image 1', required: false },
            { title: 'Image 2', required: false },
        ];
    };

    const uploadFields = getUploadFields();

    // Check if mandatory uploads are complete
    useEffect(() => {
        if (!selectedReason) {
            setMandatoryUploadsComplete(false);
            return;
        }

        const fields = getUploadFields();
        const mandatoryFields = fields.filter(f => f.required);

        if (mandatoryFields.length === 0) {
            setMandatoryUploadsComplete(true);
            return;
        }

        const allMandatoryUploaded = mandatoryFields.every(field => uploadedFiles[field.title]);
        setMandatoryUploadsComplete(allMandatoryUploaded);
    }, [uploadedFiles, selectedReason]);


    // Initialize with existing data if in update mode
    useEffect(() => {
        if (props.selectedItem) {
            setSelectedReturnItem({
                ...props.selectedItem,
                invoiceNumber: props.invoiceData?.data?.invoiceNumber || "",
            });

            // If in update mode, populate with existing data
            if (isUpdateMode && existingReturnData) {
                setReturnQty(existingReturnData.returnQty?.toString() || '');
                // setSelectedReason(existingReturnData.returnReason || '');
                setUploadedFiles(existingReturnData.returnImages || {});
                setMessage(existingReturnData.comment || '');

                if (existingReturnData.returnReason) {
                    setShowReasonWarning(warningReasons.includes(existingReturnData.returnReason));
                    setShowReasonWarningIncase(warningReasonsIncase.includes(existingReturnData.returnReason));
                }
            } else {
                // Reset form for new return request
                setReturnQty('');
                setSelectedReason('');
                setUploadedFiles({});
                setUploadProgress({});
                setShowReasonWarning(false);
                setShowReasonWarningIncase(false);
                setMessage('');
            }
        }
    }, [props.selectedItem, props.invoiceData, existingReturnData, isUpdateMode]);

    const getPrevDocId = (fieldTitle: string) => {
        return documentIds[fieldTitle] || '';
    };

    const handleBrowseFile = async (fieldTitle: string) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.jpg,.jpeg,.png,.pdf,.doc,.docx';

        input.onclick = (e: any) => {
            const { target = {} } = e || {};
            target.value = "";
            setShowErrorMessage('');
            handleopenCloseErrorSnackbar(false);
        };

        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;

            // Validate file type
            const name = file.name;
            const doctExtension = (name && name.substring(name.lastIndexOf('.') + 1, name.length)) || name;
            const doctExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'doc', 'docx'];
            const canUploadFile = doctExtensions.indexOf(doctExtension.toLowerCase()) !== -1;

            if (!canUploadFile) {
                setShowErrorMessage('Invalid File type format. Please upload jpg, jpeg, png, pdf, doc, or docx');
                handleopenCloseErrorSnackbar(true);
                return;
            }

            // Validate file size (2MB for return documents)
            const maxSize = 2000000; // 2MB
            if (file.size >= maxSize) {
                setShowErrorMessage('Please upload less than 2MB file');
                handleopenCloseErrorSnackbar(true);
                return;
            }

            // Show upload progress
            setUploadProgress(prev => ({ ...prev, [fieldTitle]: 0 }));

            // Prepare form data for API
            const formData: any = new FormData();
            const keyAttribute = `fieldname=${fieldTitle.replace(/\s+/g, "_")}&docExtension=${doctExtension}`;

            const customHeaders = {
                "Accept": "application/json",
                "Lob-Id": "AUTO",
                "Channel-Id": "B2B",
                "Org-Id": "",
                "Accept-Language": "EN",
            };

            formData.append("entityName", "CUSTOMER");
            formData.append("keyAttribute", keyAttribute);
            formData.append("fileUpload", file);
            formData.append("document", 'true');
            formData.append("Attributes", `key=ReturnReason&value=${selectedReason}`);
            formData.append("sapCustomerId", sapCustomerId ? sapCustomerId : '');
            formData.append("docType", fieldTitle);
            formData.append("label", fieldTitle.replace(/\s+/g, "_"));
            formData.append("b2bUserId", webApplicationLoginId ? webApplicationLoginId : '');
            formData.append("uploadedByRole", 'dealerUser');
            formData.append("uploadedBywebApplicationLoginId", webApplicationLoginId);
            formData.append("selectedFileName", file.name);
            formData.append("previousDocumentId", getPrevDocId(fieldTitle));
            formData.append("invoiceNumber", props.invoiceData?.data?.invoiceNumber || '');
            formData.append("materialNumber", selectedReturnItem?.materialNumber || '');

            setLoading(true);

            try {
                // Simulate progress
                let progress = 0;
                const interval = setInterval(() => {
                    progress += 20;
                    if (progress <= 80) {
                        setUploadProgress(prev => ({ ...prev, [fieldTitle]: progress }));
                    }
                }, 200);

                let uploadedDocumentData: any = await dispatch(updateDocument(formData, customHeaders));

                clearInterval(interval);

                // Check multiple possible success patterns
                let isSuccess = false;
                let errorMessage = '';

                // Pattern 1: Direct response with id and url (as per your screenshot)
                if (uploadedDocumentData?.id && uploadedDocumentData?.url) {
                    isSuccess = true;
                }
                // Pattern 2: Nested in data
                else if (uploadedDocumentData?.data?.id && uploadedDocumentData?.data?.url) {
                    uploadedDocumentData = uploadedDocumentData.data;
                    isSuccess = true;
                }
                // Pattern 3: Check message status
                else if (uploadedDocumentData?.message?.status === 'S') {
                    isSuccess = true;
                }
                // Pattern 4: Check messages array
                else if (uploadedDocumentData?.messages?.some((msg: any) => msg.code === 'CREATE_SUCCESS')) {
                    isSuccess = true;
                }

                if (isSuccess) {
                    const {
                        id,
                        url,
                        selectedFileName,
                        originalname,
                        fileName,
                        label,
                        documentStatus
                    } = uploadedDocumentData;


                    // Store document ID for future reference
                    setDocumentIds(prev => {
                        const updated = {
                            ...prev,
                            [fieldTitle]: id
                        };
                        return updated;
                    });

                    // Create a proper file object with all necessary info
                    const displayName = selectedFileName || originalname || fileName || file.name;

                    const fileObject: any = {
                        id: id,
                        url: url,
                        documentStatus: documentStatus || 'UPLOADED',
                        selectedFileName: displayName,
                        name: displayName,
                        size: file.size,
                        type: file.type,
                        lastModified: file.lastModified
                    };

                    // Update uploaded files with full document info
                    setUploadedFiles(prev => {

                        const existingFiles = prev[fieldTitle] ?? []; // if undefined or null, default to []
                        const updatedFieldFiles = [...existingFiles, fileObject];

                        return {
                            ...prev,
                            [fieldTitle]: updatedFieldFiles,
                        };
                    });
                    if (CloseButton) {
                        setNewlyUploadedFiles(prev => {
                            const existingFiles = prev[fieldTitle] || [];
                            const updatedFieldFiles = [...existingFiles, fileObject];

                            const updatedState = {
                                ...prev,
                                [fieldTitle]: updatedFieldFiles,
                            };
                            return updatedState;
                        });
                    }

                    setUploadProgress(prev => ({ ...prev, [fieldTitle]: 100 }));

                    setSuccessMessage('File uploaded successfully');
                    setOpenSnackbar(true);
                    handleopenCloseSnackbar(true);

                    setLoading(false);
                } else {
                    setLoading(false);

                    // Try to extract error message
                    errorMessage = uploadedDocumentData?.error ||
                        uploadedDocumentData?.message?.message ||
                        uploadedDocumentData?.messages?.[0]?.message ||
                        'Document upload failed';

                    setShowErrorMessage(errorMessage);
                    handleopenCloseErrorSnackbar(true);

                    // Remove progress on failure
                    setUploadProgress((prev: any) => {
                        const newProgress = { ...prev };
                        delete newProgress[fieldTitle];
                        return newProgress;
                    });
                }
            } catch (error) {
                setLoading(false);
                setShowErrorMessage('Document upload failed: ' + ((error as any)?.message || 'Unknown error'));
                handleopenCloseErrorSnackbar(true);

                setUploadProgress(prev => {
                    const newProgress = { ...prev };
                    delete newProgress[fieldTitle];
                    return newProgress;
                });
            }
        };

        input.click();
    };

    const handleRemoveFile = (fieldTitle: string, index?: number) => {


        const underscoreKey = fieldTitle.replace(/\s+/g, '_');
        const spaceKey = fieldTitle.replace(/_/g, ' ');

        const fileData =
            uploadedFiles[fieldTitle]?.[index ?? 0] ||
            uploadedFiles[underscoreKey]?.[index ?? 0] ||
            uploadedFiles[spaceKey]?.[index ?? 0];


        if (fileData && fileData.id) {
            setFilesToDelete({ [fieldTitle]: fileData });
            setFieldToDelete(fieldTitle);
            setShowDeleteConfirmDialog(true);
            removeFileFromState(fieldTitle, fileData.id);
        }
    };

    const removeFileFromState = (fieldTitle: string, fileId?: string) => {
        const underscoreKey = fieldTitle.replace(/\s+/g, '_');
        const spaceKey = fieldTitle.replace(/_/g, ' ');
        const keys = Array.from(new Set([fieldTitle, underscoreKey, spaceKey]));

        const cleanState = (state: { [key: string]: UploadedFile[] }, removeFileId?: string) => {
            const newState: { [key: string]: UploadedFile[] } = { ...state };

            keys.forEach(key => {
                if (!newState[key]) return;

                if (removeFileId) {
                    const filtered = newState[key].filter(f => f.id !== removeFileId);
                    if (filtered.length > 0) {
                        newState[key] = filtered;
                    } else {
                        delete newState[key];
                    }
                } else {
                    delete newState[key];
                }
            });

            return newState;
        };

        setUploadedFiles(prev => cleanState(prev, fileId));
        setNewlyUploadedFiles(prev => cleanState(prev, fileId));

        setUploadProgress(prev => {
            const newProgress = { ...prev };
            keys.forEach(key => delete newProgress[key]);
            return newProgress;
        });

        setDocumentIds(prev => {
            const newIds = { ...prev };
            keys.forEach(key => delete newIds[key]);
            return newIds;
        });
    };

    const deleteDocument = async () => {
        const obj = { type: 'RETURN_SALES' };
        setLoading(true);

        try {
            if (isBulkDelete) {
                const hasNewlyUploaded = newlyUploadedFiles && Object.keys(newlyUploadedFiles).length > 0;
                const filesToProcess = hasNewlyUploaded ? newlyUploadedFiles : uploadedFiles;

                for (const [fieldTitle, fileDataArray] of Object.entries(filesToProcess)) {
                    const filesArray = Array.isArray(fileDataArray) ? fileDataArray : [fileDataArray];

                    for (let index = 0; index < filesArray.length; index++) {
                        const fileData = filesArray[index];

                        if (!fileData?.id) continue;

                        // Skip only if newlyUploadedFiles exists and file is not in it
                        if (hasNewlyUploaded) {
                            const isNewlyUploaded = newlyUploadedFiles[fieldTitle]?.some(f => f.id === fileData.id);
                            if (!isNewlyUploaded) continue;
                        }

                        const res: any = await dispatch(
                            deletePartnerDocument(
                                webApplicationLoginId,
                                fileData.id,
                                obj,
                                sapCustomerId
                            )
                        );

                        if (res?.message) {
                            removeFileFromState(fieldTitle, fileData.id);
                        }
                    }
                }

                // Clean up newlyUploadedFiles state
                setNewlyUploadedFiles(prev => {
                    const updated = { ...prev };
                    Object.keys(updated).forEach(field => {
                        if (!updated[field]?.length) delete updated[field];
                    });
                    return updated;
                });

                setOpenSnackbar(true);
                setSuccessMessage('Documents deleted successfully');
                setShowUploadDialog(false);
            }
            else {
                const fileData = filesToDelete[fieldToDelete];


                if (!fileData || !fileData.id) {
                    removeFileFromState(fieldToDelete, fileData?.id);
                    setFileIndexToDelete(undefined);
                    return;
                }

                const deleteDocumentData: any = await dispatch(
                    deletePartnerDocument(
                        '',
                        fileData.id,
                        obj,
                        sapCustomerId
                    )
                );

                if (deleteDocumentData?.message) {
                    removeFileFromState(fieldToDelete, fileData.id);
                    setFileIndexToDelete(undefined);
                    setOpenSnackbar(true);
                    setSuccessMessage('Document deleted successfully');
                } else {
                    setShowErrorMessage('Failed to delete document');
                    handleopenCloseErrorSnackbar(true);
                }
            }
        } catch (error) {
            setShowErrorMessage('Failed to delete document');
            handleopenCloseErrorSnackbar(true);
        } finally {
            setLoading(false);
            setFieldToDelete('');
            setFilesToDelete({});
            setIsBulkDelete(false);
        }
    };

    const handleReasonChange = (event: any) => {
        const value = event.target.value;
        setSelectedReason(value);
        setReasonError(false);
        setUploadError(false);

        setShowReasonWarning(warningReasons.includes(value));
        setShowReasonWarningIncase(warningReasonsIncase.includes(value));

        // Clear uploaded files when reason changes
        setUploadedFiles({});
        setUploadProgress({});
    };

    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };

    const saveReturnRequest = async () => {
        setLoading(true);
        const sessionDetails = {
            webApplicationLoginId: webApplicationLoginId,
            clientIPAddress: sessionStorage.getItem('clientIp'),
        };
        let userRole: any = sessionStorage.getItem('userType-Profile-API')

        const payload = {
            "id": billingDetails?.data?.data?.data?.id,

            "itemDetails": Array.isArray(selectedReturnItem?.returnItem)
                ? selectedReturnItem.returnItem.map((item: any) => ({
                    materialNumber: item.materialNumber,
                    itemId: item.itemId,
                    returnQty: Number(item.returnQty || 1),
                    reason: selectedReason,
                    billingItem: selectedReturnItem?.billingItem,
                    returnImages: Object.fromEntries(
                        Object.entries(uploadedFiles).map(([key, fileArray]) => {
                            const imageKey = key.replace(/\s+/g, "_");
                            const files = Array.isArray(fileArray) ? fileArray : fileArray ? [fileArray] : [];
                            return [
                                imageKey,
                                files.map(file => ({
                                    id: file?.id || "",
                                    name: file?.name || "",
                                    url: file?.url || ""
                                }))
                            ];
                        })
                    ), ...(selectedReason === "06 - Customer Cancelled" && { comment: message })

                }))
                : [], // Fallback for single item
            "createdBy": isFSE ? billingDetails?.data?.data?.data?.customerName : customerName,
            "sapCustomerId": isFSE ? billingDetails?.data?.data?.data?.sapCustomerId : sapCustomerId,
            sessionDetails,
            customerTierType: updatedCustomerTierType,
            "role": userRole,
            "etag": currentEtag || billingDetails?.data?.data?.data?._etag
        };

        let responseData: any = await dispatch(saveReturnRequestAPI(payload));

        if (responseData && responseData.status === 400) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage(responseData?.error);
            setLoading(false);
        } else {
            setOpenErrorSnackbar(false);
            handleopenCloseSnackbar(true);
            setSuccessMessage(responseData && responseData.message && responseData.message.message);
            setLoading(false);

            // Extract etag from response
            const newEtag: any = responseData?.data?.data?._etag;
            handleConfirmYes(newEtag);
        }
    };

    const handleProceed = () => {
        setShowConfirmDialog(true);
    };

    const handleConfirmYes = (responseEtag?: string) => {
        setShowConfirmDialog(false);

        // Call the callback to update parent component with materialNumber and etag
        if (onReturnSuccess && selectedReturnItem) {
            onReturnSuccess(selectedReturnItem.materialNumber, {
                returnQty: Number(returnQty),
                returnReason: selectedReason,
                returnImages: uploadedFiles,
                comment: message
            }, responseEtag);
        }

        // Reset form
        setReturnQty('');
        setSelectedReason('');
        setUploadedFiles({});
        setUploadProgress({});
        setMessage('');
        handleopenClose();
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const isBrowseFileDisabled = selectedReason === "";

    const formatFileSize = (bytes: number) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i)) + ' ' + sizes[i];
    };

    const canUploadImages = Boolean(selectedReason);

    return (
        <Fragment>
            {loading && <FullscreenLoader />}
            {billingDetails && billingDetails.loading && <FullscreenLoader />}

            <Snackbar
                open={openSnackbar}
                message={successMessage}
                handleopenClose={() => handleopenCloseSnackbar(false)}
            />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                message={showErrorMessage}
                handleopenClose={() => handleopenCloseErrorSnackbar(false)}
            />

            {/* Main Return Request Dialog */}
            <Dialog
                open={props.open}
                className='quotation'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'sm'}
                fullWidth
            >
                <div className={classes.root}>
                    <Toolbar className={clsx(classes.root)} style={{ minHeight: 56 }}>
                        <div className="col-12" style={{ padding: '4px 0' }}>
                            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                <h4 className="shift-to-party-page-title" style={{ margin: 0 }}>
                                    <div className={classes.addUpdateDailogTitle}>
                                        {isUpdateMode ? 'Update' : 'Request'} Return Order
                                        <span className={classes.invoiceNumber}>
                                            (Invoice No: {props.invoiceData?.data?.invoiceNumber || '-'})
                                        </span>
                                    </div>
                                    <IconButton aria-label="close" className="float-right" onClick={handleopenClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </h4>
                            </Typography>
                        </div>
                    </Toolbar>
                </div>
                <DialogContent className={classes.dialogContent}>
                    {/* Table Header */}
                    <div className={classes.tableHeader}>

                        <div className="px-2 dealer-table-title">Reason</div>
                        <div className="dealer-table-title">Upload Proof/Reference</div>
                    </div>

                    {/* Table Row */}
                    <div className={classes.tableRow}>
                        {/* Reason Select */}
                        <div className='pl-2'>
                            <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                                className={classes.selectField}
                                error={reasonError}
                            >
                                <Select
                                    value={selectedReason}
                                    onChange={handleReasonChange}
                                    displayEmpty
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        getContentAnchorEl: null
                                    }}
                                >
                                    <MenuItem value="" style={{ display: "none" }}>
                                        <em>Select Reason*</em>
                                    </MenuItem>
                                    {reasonOptions.map((reason) => (
                                        <MenuItem key={reason} value={reason}>
                                            {reason}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {showReasonWarning && (
                                <div className={classes.warningText}>
                                    Ensure the product and packaging are intact and free from any damage.
                                </div>
                            )}
                            {showReasonWarningIncase && (
                                <div className={classes.warningText}>
                                    Please upload the mandatory images by clicking on the ‘Browse File’ button.
                                </div>
                            )}
                        </div>

                        {/* Upload Button */}
                        <div>
                            <Button
                                className={classes.browseButton}
                                onClick={() => setShowUploadDialog(true)}
                                disabled={isBrowseFileDisabled}
                            >
                                Browse File
                            </Button>
                            <div className={classes.fileInfo}>
                                Recommended File Extension:<br />
                                (.Jpg, .Jpeg, .Png, .Pdf, .Doc, Docx)<br />
                                upto 5 MB can be uploaded.
                            </div>
                        </div>
                    </div>
                    {selectedReason === "06 - Customer Cancelled" && (
                        <div className="m-4 w-auto">
                            <TextField
                                placeholder="Message *"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                variant="outlined"
                                size="small"
                                fullWidth
                                multiline
                                rows={3}
                                className={classes.inputField}
                                inputProps={{ maxLength: 200 }}
                            />
                        </div>
                    )}

                    {/* Display uploaded images */}
                    {canUploadImages && !showUploadDialog && Object.keys(uploadedFiles || {}).length > 0 && (
                        <div
                            style={{
                                marginTop: 20,
                                padding: '16px 24px',
                                borderTop: '1px solid #e0e0e0'
                            }}
                        >
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(5, 1fr)',
                                    gap: '16px',
                                }}
                            >
                                {getUploadFields().map((field, index) => {
                                    const key = field.title.replace(/\s+/g, '_');
                                    const files: UploadedFile[] = uploadedFiles[key] || uploadedFiles[field.title] || [];

                                    return (
                                        <div key={index}>
                                            <div
                                                className={classes.cellText}
                                                style={{
                                                    fontWeight: 600,
                                                    marginBottom: 4,
                                                    color: '#333333'
                                                }}
                                            >
                                                {field.title}
                                            </div>
                                            <div
                                                className={classes.cellText}
                                                style={{
                                                    fontSize: '0.75rem',
                                                    color: '#666666',
                                                    wordBreak: 'break-word'
                                                }}
                                            >
                                                {Array.isArray(files) && files.length > 0 ? (
                                                    files.map((file, idx) => (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                marginBottom: 2
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    textDecoration: 'underline',
                                                                    color: '#1DA1F2',
                                                                    cursor: 'pointer',
                                                                    fontSize: '0.75rem',
                                                                    wordBreak: 'break-word',
                                                                    maxWidth: '150px'
                                                                }}
                                                                onClick={() => file?.url && window.open(file.url, '_blank')}
                                                            >
                                                                {file.selectedFileName || file.name || 'View File'}
                                                            </span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    '-'
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </DialogContent>

                <DialogActions className={classes.dialogActions}>
                    <Button
                        variant="contained"
                        className={classes.proceedButton}
                        onClick={handleProceed}
                        disabled={(!selectedReason) || (selectedReason === "06 - Customer Cancelled" && !message.trim())}
                    >
                        Proceed
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.closeButton}
                        onClick={handleopenClose}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Upload Proof/Reference Dialog */}
            <Dialog
                open={showUploadDialog}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    setShowUploadDialog(false);
                }}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                className='quotation'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'sm'}
                fullWidth
            >
                <div className={classes.root}>
                    <Toolbar className={clsx(classes.root)} style={{ minHeight: 56 }}>
                        <div className="col-12" style={{ padding: '4px 0' }}>
                            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                                <h4 className="shift-to-party-page-title" style={{ margin: 0 }}>
                                    <div className={`mt-3 mb-4 ${classes.addUpdateDailog}`}>
                                        Upload Proof/Reference
                                    </div>
                                </h4>
                            </Typography>
                        </div>
                    </Toolbar>
                </div>
                <DialogContent style={{ padding: '0 24px' }}>
                    <div className={classes.uploadTableHeader}>
                        <div className={'dealer-table-title'}>Title</div>
                        <div className={"dealer-table-title"}>Image</div>
                        <div className={"dealer-table-title"}>Action</div>
                    </div>

                    {getUploadFields().map((field, index) => (
                        <div
                            key={index}
                            className={classes.uploadTableRow}
                            style={{ alignItems: 'flex-start' }}
                        >
                            <div className={classes.uploadCellTitle}>
                                {field.title}
                                {field.required && <span style={{ color: '#FF9800' }}> *</span>}
                            </div>

                            <div>
                                {uploadedFiles[field.title] && uploadedFiles[field.title]!.length > 0 ? (
                                    uploadedFiles[field.title]!.map((file, idx) => (
                                        <div
                                            key={idx}
                                            className="file-name"
                                            style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}
                                        >
                                            <span
                                                className="cursor-pointer"
                                                style={{
                                                    fontSize: '0.75rem',
                                                    color: '#1DA1F2',
                                                    textDecoration: 'underline',
                                                    cursor: 'pointer',
                                                    wordBreak: 'break-all',
                                                    maxWidth: '150px',
                                                }}
                                                onClick={() => {
                                                    if (file?.url) {
                                                        window.open(file.url, '_blank');
                                                    }
                                                }}
                                            >
                                                {file?.selectedFileName || file?.name || 'View File'}
                                            </span>

                                            <IconButton
                                                className="p-1"
                                                aria-label="delete"
                                                onClick={() => handleRemoveFile(field.title, idx)}
                                                style={{ marginLeft: 8 }}
                                            >
                                                <CancelIcon style={{ fontSize: 18, color: '#FF5252' }} />
                                            </IconButton>
                                        </div>
                                    ))
                                ) : uploadProgress[field.title] !== undefined ? (
                                    <div className={classes.progressContainer}>
                                        <div className={classes.progressBar}>
                                            <div
                                                className={classes.progressFill}
                                                style={{
                                                    width: `${uploadProgress[field.title]}%`,
                                                }}
                                            />
                                        </div>
                                        <span className={classes.fileInfoText}>
                                            {uploadProgress[field.title]}%
                                        </span>
                                    </div>
                                ) : (
                                    <span className={classes.cellText}>-</span>
                                )}
                            </div>
                            <div>
                                <Button
                                    className={classes.browseButton}
                                    onClick={() => handleBrowseFile(field.title)}
                                    disabled={
                                        uploadProgress[field.title] !== undefined &&
                                        uploadProgress[field.title] < 100
                                    }
                                >
                                    Browse File
                                </Button>
                            </div>
                        </div>
                    ))}

                    <div className={classes.uploadNote}>
                        Note: Recommended File Extension:<br />
                        (.Jpg, .Jpeg, .Png, .Pdf, .Doc, Docx) Upto max 2 MB each can be uploaded.
                    </div>
                </DialogContent>

                <DialogActions className={classes.uploadActions}>
                    <Button
                        variant="contained"
                        className={classes.uploadButton}
                        onClick={() => {
                            // Validate mandatory uploads before closing
                            const fields = getUploadFields();
                            const mandatoryFields = fields.filter(f => f.required);
                            const missingFields = mandatoryFields.filter(field => !uploadedFiles[field.title]);

                            if (missingFields.length > 0) {
                                setOpenErrorSnackbar(true);
                                handleopenCloseErrorSnackbar(true);
                                setShowErrorMessage('Please upload all mandatory images: ' + missingFields.map(f => f.title).join(', '));
                                return;
                            }
                            setCloseButton(true);
                            setNewlyUploadedFiles({});
                            setShowUploadDialog(false);
                        }}
                    >
                        Upload
                    </Button>
                    <Button
                        variant="contained"
                        className={classes.cancelButton}
                        onClick={() => {
                            if (CloseButton === true) {
                                if (newlyUploadedFiles && Object.keys(newlyUploadedFiles).length > 0) {
                                    setIsBulkDelete(true);
                                    setShowDeleteConfirmDialog(true);
                                } else {
                                    setShowUploadDialog(false);
                                    return;
                                }
                            } else {
                                if (!uploadedFiles || Object.keys(uploadedFiles).length === 0) {
                                    setShowUploadDialog(false);
                                    return;
                                }

                                setIsBulkDelete(true);
                                setShowDeleteConfirmDialog(true);
                            }
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={showDeleteConfirmDialog}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    setShowDeleteConfirmDialog(false);
                }}
                TransitionProps={{
                    onExited: () => setIsBulkDelete(false)
                }}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                fullWidth
            >
                <DialogContent>
                    <div className={classes.icon}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                    </div>
                    <DialogContentText id="alert-dialog-description" component="div">
                        <div className={`mt-3 ${classes.cancelText}`}>
                            {isBulkDelete
                                ? 'Do you wish to leave without uploading your details?'
                                : 'Do you want to delete this document?'}
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={`mx-4 ${classes.yes}`} onClick={() => { setShowDeleteConfirmDialog(false); deleteDocument(); }} autoFocus>
                        Yes
                    </Button>
                    <Button
                        className={`mr-4 ${classes.cancel}`}
                        onClick={() => {
                            setShowDeleteConfirmDialog(false);
                            setFieldToDelete('');
                            setFilesToDelete({});
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <Dialog
                open={showConfirmDialog}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    setShowConfirmDialog(false);
                }}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                fullWidth
            >
                <DialogContent>
                    <div className={classes.icon}>
                        <WarningIcon className="delete-warning" fontSize="small" />
                    </div>
                    <DialogContentText id="alert-dialog-description" component="div">
                        <div className={`mt-3 ${classes.cancelText}`}>
                            Do you want to return all items of this invoice ?
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className={`mx-4 ${classes.yes}`} onClick={
                        saveReturnRequest
                    }
                        autoFocus>
                        Yes
                    </Button>
                    <Button className={`mr-4 ${classes.cancel}`} onClick={() => { setShowConfirmDialog(false); handleopenClose(); }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
}